(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('localizerConfig', function() {
        return factory(root);
      });
  } else {
    root.localizerConfig = factory(root);
  }
})(this, function(root) {

	var oneYear = 365*24*60*60*1000; // a year in milliseconds
	var sixHundredDays = 600*24*60*60*1000 // 600 days in milliseconds
	var session = 0;
	var oneHour = 60*60*1000 // an hour in milliseconds

	var localizerConfig = {
				storageConfig : {
					THD_INTERNAL: {
						LOCALIZED_BY_GPS_HIGH: 		{ storage : 'cookie', expiry: session },
						LOCALIZED_BY_STORE: 			{ storage : 'cookie', expiry: oneYear },
						LOCALIZED_BY_FUZZY_STORE: { storage : 'cookie', expiry: session },
						LOCALIZED_BY_DEFAULT: 		{ storage : 'cookie',	expiry: session },
						LOCALIZED_BY_GPS_MEDIUM: 	{ storage : 'cookie', expiry: session },
						LOCALIZED_BY_GPS_LOW: 		{ storage : 'cookie', expiry: session },
						THD_STORE_LOCATION: 			{ storage : 'cookie', expiry: session },
						KNOWN_LOCATION: 					{ storage : 'cookie', expiry: session },
						LOC_HISTORY_BY_IP: 				{ storage : 'cookie', expiry: session },
						LOC_HISTORY_BY_SUBNET: 		{ storage : 'cookie', expiry: session },
						GEO_LOCATION: 						{ storage : 'cookie', expiry: session },
						DEFAULT_INTERNAL: 				{ storage : 'cookie', expiry: session },
						DEFAULT: 									{ storage : 'cookie', expiry: session },
						DEFAULT_STORAGE: 					{ storage : 'cookie', expiry: session }
					},
					THD_FORCE_LOC: {
						LOCALIZED_BY_GPS_HIGH: 		{ storage : 'cookie', expiry: session },
						LOCALIZED_BY_STORE: 			{ storage : 'cookie', expiry: oneYear },
						LOCALIZED_BY_FUZZY_STORE: { storage : 'cookie', expiry: session },
						LOCALIZED_BY_DEFAULT: 		{ storage : 'cookie', expiry: session },
						LOCALIZED_BY_GPS_MEDIUM: 	{ storage : 'cookie', expiry: session },
						LOCALIZED_BY_GPS_LOW: 		{ storage : 'cookie', expiry: session },
						THD_STORE_LOCATION: 			{ storage : 'cookie', expiry: session },
						KNOWN_LOCATION: 					{ storage : 'cookie', expiry: session },
						LOC_HISTORY_BY_IP: 				{ storage : 'cookie', expiry: session },
						LOC_HISTORY_BY_SUBNET: 		{ storage : 'cookie', expiry: session },
						GEO_LOCATION: 						{ storage : 'cookie', expiry: session },
						DEFAULT_INTERNAL: 				{ storage : 'cookie', expiry: session },
						DEFAULT: 									{ storage : 'cookie', expiry: session },
						DEFAULT_STORAGE: 					{ storage : 'cookie', expiry: session }
					},
					THD_LOCSTORE: {
						LOCALIZED_BY_GPS_HIGH:  	{ storage : 'cookieCrumb', expiry: oneYear },
						LOCALIZED_BY_STORE: 			{ storage : 'cookieCrumb', expiry: oneYear },
						LOCALIZED_BY_FUZZY_STORE: { storage : 'cookieCrumb', expiry: oneYear },
						LOCALIZED_BY_DEFAULT: 		{ storage : 'cookieCrumb', expiry: oneYear },
						LOCALIZED_BY_GPS_MEDIUM: 	{ storage : 'cookieCrumb', expiry: oneYear },
						LOCALIZED_BY_GPS_LOW: 		{ storage : 'cookieCrumb', expiry: oneYear },
						THD_STORE_LOCATION: 			{ storage : 'cookieCrumb', expiry: oneYear },
						KNOWN_LOCATION: 					{ storage : 'cookieCrumb', expiry: oneYear },
						LOC_HISTORY_BY_IP: 				{ storage : 'cookieCrumb', expiry: oneYear },
						LOC_HISTORY_BY_SUBNET: 		{ storage : 'cookieCrumb', expiry: oneYear },
						GEO_LOCATION: 						{ storage : 'cookieCrumb', expiry: oneYear },
						DEFAULT_INTERNAL: 				{ storage : 'cookieCrumb', expiry: oneYear },
						DEFAULT: 									{ storage : 'cookieCrumb', expiry: oneYear },
						DEFAULT_STORAGE: 					{ storage : 'cookieCrumb', expiry: oneYear }
					},
					WORKFLOW: 									{ storage : 'cookie', 			 expiry: oneYear   },
					GPS_STATUS: 								{ storage : 'session', 		 expiry: undefined },
					localizationMethod: 				{ storage : 'local', 		 	 expiry: undefined },
					HTTP_URL: 									{ storage : 'http', 			 expiry: undefined },
					DEFAULT_STORAGE: 						{ storage : 'cookie', 		 expiry: session   },
					THD_INSTORE: 								{ storage : 'cookie', 		 expiry: session	 },
					THD_STORE_INFO:{
              LOCALIZED_BY_STORE: 		{ storage : 'cookie',      expiry: oneYear   },
              DEFAULT_STORAGE:        { storage : 'cookie', 		 expiry: session	 }
          },
					THD_STRFINDERZIP: 				  { storage : 'cookieCrumb', expiry: oneYear	 },
					THD_STORE_HOURS: 						{ storage : 'cookieCrumb', expiry: oneHour	 },
					loc_version: 								{ storage : 'session', 		 expiry: undefined },
					THD_CA_USER: 								{ storage : 'cookie', 		 expiry: sixHundredDays },
					THD_AUTOLOCINTERCEPT: 			{ storage : 'cookie', 		 expiry: sixHundredDays },

					// Some of the code is redundent, Added to support the migration. Can be cleaned up
					// once all consumers migrated to standardized localizer.
					get: function(key, workflow) {
						var storageConfig;
						// If key is not among the standard defined here, use cookie as default storage
						if(this[key] === undefined) {
							return this.DEFAULT_STORAGE;
						}
						if(!workflow) {
							/* If worklow is not defined, and the key is among the standard keys defined here
								 then use the default storage for that key.
							 */
							storageConfig = this[key].DEFAULT_STORAGE;
							/* If key is independent of the workflow, then key's value itself is storage config.
								 Eg: WORKFLOW, localization method etc.
							 */
							if(storageConfig === undefined) {
								storageConfig = this[key];
							}
						} else {
              // If key is defined and workflow is not defined (irrespective of any workflow), then use the default storage for that key
              if(this[key] && !this[key][workflow]) {
                storageConfig = this[key]['DEFAULT_STORAGE'];
              } else {
                // If key and workflow are defined and key is among the standard defined here
  							storageConfig = this[key][workflow];
              }
						}
						return storageConfig;
					}
				}
			}
	return localizerConfig;
})



//////////////////
// WEBPACK FOOTER
// ./src/localizerConfig.js
// module id = 7
// module chunks = 0